import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

const translations = {
  Home: "Hem",
  Products: "Produkter",
  Categories: "Kategorier",
  Deals: "Erbjudanden",
  Contact: "Kontakt",
  Cart: "Varukorg",
  "All Products": "Alla produkter",
  "Best Sellers": "Bästsäljare",
  "Deals & Offers": "Erbjudanden",
  "About Us": "Om oss",
  "Learn more about Ferramentum and the company behind our store.":
    "Läs mer om Ferramentum och företaget bakom vår butik.",
  Breadcrumb: "Brödsmula",
  "Reliable tools, straightforward service, and practical support for every project.":
    "Pålitliga verktyg, tydlig service och praktisk support för alla projekt.",
  "The company behind Ferramentum": "Företaget bakom Ferramentum",
  "Ferramentum is an online store for dependable tools and equipment, operated by a Swedish company committed to making every purchase clear and reliable.":
    "Ferramentum är en nätbutik för pålitliga verktyg och utrustning, som drivs av ett svenskt företag med målet att göra varje köp tydligt och tryggt.",
  "Company information": "Företagsinformation",
  "Our legal details": "Våra företagsuppgifter",
  "Company name": "Företagsnamn",
  "VAT number": "Momsregistreringsnummer",
  "Registered address": "Registrerad adress",
  "Need to get in touch?": "Behöver du kontakta oss?",
  "Our team is ready to help with questions about products, orders, or delivery.":
    "Vårt team hjälper gärna till med frågor om produkter, beställningar eller leverans.",
  Careers: "Karriär",
  "Career information and opportunities at Ferramentum.":
    "Karriärinformation och möjligheter hos Ferramentum.",
  "We are building Ferramentum carefully and growing at a steady pace.":
    "Vi bygger Ferramentum med omsorg och växer i en jämn takt.",
  "No open positions right now": "Inga lediga tjänster just nu",
  "We are a small, growing team and are not currently hiring. If you are passionate about practical tools, thoughtful service, and building a dependable online store, we would still be glad to hear from you.":
    "Vi är ett litet team i tillväxt och rekryterar inte just nu. Om du brinner för praktiska verktyg, genomtänkt service och att bygga en pålitlig nätbutik får du ändå gärna höra av dig.",
  "Send your resume and a short introduction to":
    "Skicka ditt CV och en kort presentation till",
  "How we work": "Så arbetar vi",
  "Practical, direct, and customer-focused":
    "Praktiskt, tydligt och kundfokuserat",
  "We value clear communication, useful work, and taking responsibility for the customer experience from product selection through delivery.":
    "Vi värdesätter tydlig kommunikation, nyttigt arbete och ansvar för kundupplevelsen från produktval till leverans.",
  "Questions about working with us?": "Frågor om att arbeta med oss?",
  "Contact our team at": "Kontakta vårt team på",
  Blog: "Blogg",
  Press: "Press",
  "Press information and media resources for Ferramentum.":
    "Pressinformation och medieresurser för Ferramentum.",
  "Information and resources for media enquiries about Ferramentum.":
    "Information och resurser för medieförfrågningar om Ferramentum.",
  "About Ferramentum": "Om Ferramentum",
  "Tools for practical work": "Verktyg för praktiskt arbete",
  "Ferramentum is a Swedish online store for dependable tools and equipment. We exist to make it easier for people to find practical products for their projects, with straightforward service and reliable delivery.":
    "Ferramentum är en svensk nätbutik för pålitliga verktyg och utrustning. Vi finns för att göra det enklare att hitta praktiska produkter för olika projekt, med tydlig service och pålitliga leveranser.",
  "Media kit": "Mediepaket",
  "Ferramentum logo PNG": "Ferramentums PNG-logotyp",
  "Ferramentum logo SVG": "Ferramentums SVG-logotyp",
  "Download PNG": "Ladda ner PNG",
  "Download SVG": "Ladda ner SVG",
  "Product images": "Produktbilder",
  "Ferramentum product": "Ferramentum-produkt",
  "Brand basics:": "Varumärkesgrunder:",
  "Primary orange #FF6600, black, and white. Headings use Poppins; interface text uses Inter.":
    "Primär orange #FF6600, svart och vitt. Rubriker använder Poppins och gränssnittstext använder Inter.",
  "Company boilerplate": "Företagspresentation",
  "Ferramentum is a Swedish online store offering dependable tools and equipment for practical projects, backed by straightforward service and reliable delivery.":
    "Ferramentum är en svensk nätbutik som erbjuder pålitliga verktyg och utrustning för praktiska projekt, med tydlig service och pålitliga leveranser.",
  "Media enquiries": "Medieförfrågningar",
  "For media enquiries, please contact us at":
    "För medieförfrågningar, kontakta oss på",
  Partners: "Partner",
  "Ferramentum currently operates independently with no partners.":
    "Ferramentum drivs för närvarande verksamheten självständigt utan partners.",
  "Operating independently": "Självständig verksamhet",
  "We currently run Ferramentum on our own and do not have any partners. Our team manages the store, customer service, and deliveries directly.":
    "Vi driver för närvarande Ferramentum på egen hand och har inga partners. Vårt team hanterar butiken, kundservicen och leveranserna direkt.",
  "For general enquiries, please get in touch with our team.":
    "För allmänna frågor är du välkommen att kontakta vårt team.",
  "General enquiries": "Allmänna frågor",
  "Returns & Refunds": "Returer & återbetalningar",
  FAQs: "Vanliga frågor",
  "Affordable quality. Unbreakable spirit.":
    "Prisvärd kvalitet. Obrutbar anda.",
  Shop: "Handla",
  Company: "Företag",
  "Stay Updated": "Håll dig uppdaterad",
  "Subscribe for exclusive deals, new arrivals & tool tips.":
    "Prenumerera för exklusiva erbjudanden, nyheter & verktygstips.",
  "Your email address": "Din e-postadress",
  "No spam ever. Unsubscribe anytime.":
    "Ingen skräppost. Avsluta prenumerationen när som helst.",
  "Subscribed successfully!": "Prenumeration registrerad!",
  "Product not found": "Produkten hittades inte",
  "Browse Products": "Bläddra bland produkter",
  review: "recension",
  reviews: "recensioner",
  Save: "Spara",
  "Added!": "Tillagd!",
  "Related Products": "Relaterade produkter",
  "No description available for this product.":
    "Ingen beskrivning tillgänglig för denna produkt.",
  "Please login to use wishlist":
    "Vänligen logga in för att använda önskelistan",
  "Exclusive Deals": "Exklusiva erbjudanden",
  "Save big on top-rated tools and enjoy free delivery on select items.":
    "Spara stort på topprankade verktyg och få fri frakt på utvalda produkter.",
  "Flash Sales": "Blixtutförsäljning",
  "Free Delivery Items": "Produkter med fri frakt",
  "No active deals found": "Inga aktiva erbjudanden hittades",
  "We're currently updating our offers. Check back soon for new discounts and free shipping deals!":
    "Vi uppdaterar för närvarande våra erbjudanden. Kom tillbaka snart för nya rabatter och fri frakt!",
  "Browse All Products": "Visa alla produkter",
  "Browse Categories": "Bläddra i kategorier",
  "Find exactly what you need for your next project":
    "Hitta exakt vad du behöver för ditt nästa projekt",
  Product: "Produkt",
  Explore: "Utforska",
  "No categories found": "Inga kategorier hittades",
  "We're currently updating our catalog. Please check back later.":
    "Vi uppdaterar för närvarande vår produktkatalog. Vänligen kom tillbaka senare.",
  Sweden: "Sverige",
  "Registration failed. Please try again.":
    "Registreringen misslyckades. Vänligen försök igen.",
  "Creating Account...": "Skapar konto...",
  "Join Ferramentum for exclusive deals and faster checkout":
    "Gå med i Ferramentum för exklusiva erbjudanden och snabbare kassa",
  "Check Your Email": "Kontrollera din e-post",
  "Back to Login": "Tillbaka till inloggning",
  "Forgot Password?": "Glömt lösenord?",
  "Enter your email and we'll send you a link to reset your password.":
    "Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.",
  "Sending...": "Skickar...",
  "Send Reset Link": "Skicka återställningslänk",
  "Remember your password?": "Kommer du ihåg ditt lösenord?",
  "Something went wrong.": "Något gick fel.",
  "Passwords do not match.": "Lösenorden matchar inte.",
  "Password Reset Successful": "Lösenordsåterställning lyckades",
  "Redirecting to login...": "Omdirigerar till inloggning...",
  "Go to Login": "Gå till inloggning",
  "Resetting...": "Återställer...",
  "Please enter your new password below.":
    "Vänligen ange ditt nya lösenord nedan.",
  "Confirm New Password": "Bekräfta nytt lösenord",
  "Street Address": "Gatuadress",
  Alerts: "Aviseringar",
  Notifications: "Aviseringar",
  "Mark all read": "Markera alla som lästa",
  "No notifications yet": "Inga aviseringar än",
  "View all notifications": "Visa alla aviseringar",
  "My Orders": "Mina beställningar",
  Wishlist: "Önskelista",
  Settings: "Inställningar",
  Logout: "Logga ut",
  "Welcome to Ferramentum": "Välkommen till Ferramentum",
  "Sign in to track orders, save wishlist & more":
    "Logga in för att spåra beställningar, spara önskelista och mer",
  Account: "Konto",
  Login: "Logga in",
  "Create Account": "Skapa konto",
  "Quick Links": "Snabblänkar",
  Support: "Kundtjänst",
  Legal: "Villkor",
  Newsletter: "Nyhetsbrev",
  "Subscribe to get the latest deals and updates.":
    "Prenumerera för att få de senaste erbjudandena och uppdateringarna.",
  "Email Address": "E-postadress",
  Subscribe: "Prenumerera",
  "All rights reserved.": "Alla rättigheter förbehållna.",
  "Tools for Every Task": "Verktyg för alla uppgifter",
  "Built to Perform": "Byggda för att prestera",
  "Dependable tools and smart solutions for work, workshop, and home.":
    "Pålitliga verktyg och smarta lösningar för arbete, verkstad och hem.",
  "Shop Tools": "Handla verktyg",
  "Special Offers": "Specialerbjudanden",
  "Save on Selected Tools": "Spara på utvalda verktyg",
  "Get more done with great prices on tools chosen for the job.":
    "Få mer gjort med bra priser på verktyg utvalda för jobbet.",
  "See Offers": "Se erbjudanden",
  "New Arrivals": "Nyinkommet",
  "Fresh Gear": "Ny utrustning",
  "Ready for Your Next Project": "Redo för ditt nästa projekt",
  "Discover the latest tools and equipment added to Ferramentum.":
    "Upptäck de senaste verktygen och den senaste utrustningen hos Ferramentum.",
  "Shop New Arrivals": "Handla nyheter",
  "Browse All": "Bläddra bland alla",
  All: "Alla",
  "View All": "Visa alla",
  "No products found.": "Inga produkter hittades.",
  "Search products...": "Sök produkter...",
  "Grid view": "Rutnät",
  "List view": "Lista",
  "Sort By": "Sortera efter",
  "Newest First": "Nyast först",
  "Oldest First": "Äldst först",
  "Price: Low to High": "Pris: Lågt till högt",
  "Price: High to Low": "Pris: Högt till lågt",
  "Name: A–Z": "Namn: A–Ö",
  "Name: Z–A": "Namn: Ö–A",
  "Most Popular": "Mest populära",
  "No Products Found": "Inga produkter hittades",
  "Try adjusting your search or filters":
    "Försök att justera din sökning eller filter",
  "Reset Filters": "Återställ filter",
  Category: "Kategori",
  Sort: "Sortera",
  "Add to Cart": "Lägg i varukorg",
  "Out of Stock": "Slutsåld",
  Quantity: "Antal",
  Description: "Beskrivning",
  Specifications: "Specifikationer",
  Reviews: "Recensioner",
  Price: "Pris",
  Brand: "Märke",
  SKU: "Artikelnummer",
  Availability: "Tillgänglighet",
  "In Stock": "I lager",
  Rating: "Betyg",
  "Hot Deals": "Heta erbjudanden",
  "Save big on our finest tools and equipment.":
    "Spara stort på våra finaste verktyg och utrustning.",
  "Explore our wide range of professional tools by category.":
    "Utforska vårt breda sortiment av professionella verktyg per kategori.",
  "Browse Category": "Bläddra i kategori",
  "Contact Us": "Kontakta oss",
  "Get in touch with our support team.": "Kontakta vår supportavdelning.",
  "Your Name": "Ditt namn",
  Email: "E-post",
  Subject: "Ämne",
  Message: "Meddelande",
  "Send Message": "Skicka meddelande",
  "Thank you for your message. We will get back to you soon.":
    "Tack för ditt meddelande. Vi återkommer snart.",
  "Please fill in all fields.": "Vänligen fyll i alla fält.",
  "Welcome Back": "Välkommen tillbaka",
  "Sign in to continue to your account":
    "Logga in för att fortsätta till ditt konto",
  "Forgot password?": "Glömt lösenordet?",
  Password: "Lösenord",
  Loading: "Laddar",
  "Sign In": "Logga in",
  "Please complete the security check.":
    "Vänligen slutför säkerhetskontrollen.",
  "Login failed.": "Inloggningen misslyckades.",
  "Join us to track orders and save products.":
    "Gå med oss för att spåra beställningar och spara produkter.",
  "Full Name": "Fullständigt namn",
  "Confirm Password": "Bekräfta lösenord",
  Register: "Registrera dig",
  "Already have an account?": "Har du redan ett konto?",
  "Forgot Password": "Glömt lösenordet",
  "Enter your email to receive a password reset link.":
    "Ange din e-postadress för att få en återställningslänk.",
  "Reset Password": "Återställ lösenord",
  "Enter your new password below.": "Ange ditt nya lösenord nedan.",
  "New Password": "Nytt lösenord",
  "My Wishlist": "Min önskelista",
  "Your wishlist is empty.": "Din önskelista är tom.",
  "Start shopping to add items.": "Börja handla för att lägga till produkter.",
  "Account Settings": "Kontoinställningar",
  "Profile Information": "Profilinformation",
  "Notification Preferences": "Aviseringsinställningar",
  Security: "Säkerhet",
  "Save Changes": "Spara ändringar",
  "Saving...": "Sparar...",
  "Settings updated successfully.": "Inställningarna har uppdaterats.",
  "Current Password": "Nuvarande lösenord",
  "Update Password": "Uppdatera lösenord",
  "Shopping Cart": "Varukorg",
  "Your cart is empty": "Din varukorg är tom",
  Subtotal: "Delsumma",
  Checkout: "Kassa",
  Remove: "Ta bort",
  "Shipping Address": "Leveransadress",
  "Payment Method": "Betalmetod",
  Card: "Kort",
  Klarna: "Klarna",
  "Apple Pay": "Apple Pay",
  "Google Pay": "Google Pay",
  PayPal: "PayPal",
  "Amazon Pay": "Amazon Pay",
  "Order Summary": "Orderöversikt",
  "Place Order": "Slutför köp",
  Address: "Adress",
  City: "Stad",
  State: "Län",
  "Postal Code": "Postnummer",
  Country: "Land",
  "Cardholder Name": "Kortinnehavarens namn",
  "Card Number": "Kortnummer",
  "Expiry Date": "Utgångsdatum",
  CVV: "CVV",
  "Processing...": "Bearbetar...",
  "Order placed successfully!": "Beställningen har lagts!",
  Order: "Beställning",
  Date: "Datum",
  Status: "Status",
  Total: "Totalt",
  Actions: "Åtgärder",
  "Order Details": "Orderdetaljer",
  "Shipping Info": "Leveransinfo",
  "Payment Info": "Betalningsinfo",
  "Items Ordered": "Beställda produkter",
  "Order History": "Orderhistorik",
  "You have no orders yet.": "Du har inga beställningar än.",
  "Support Tickets": "Supportärenden",
  "Create Ticket": "Skapa ärende",
  "Open Tickets": "Öppna ärenden",
  "Resolved Tickets": "Lösta ärenden",
  "Last Updated": "Senast uppdaterad",
  "Ticket Details": "Ärendedetaljer",
  Replies: "Svar",
  "Add Reply": "Skriv svar",
  "Submit Ticket": "Skapa ärende",
  "Welcome to help center": "Välkommen till kundtjänst",
  "How can we help you today?": "Hur kan vi hjälpa dig idag?",
  "Search help articles...": "Sök i hjälpartiklar...",
  "Frequently Asked Questions": "Vanliga frågor och svar",
  "Popular Articles": "Populära artiklar",
  "Ticket Subject": "Ämnesrubrik",
  "Brief description of your issue": "Kort beskrivning av ditt ärende",
  "Ticket Description": "Beskrivning av ärende",
  "Provide detailed information": "Ange detaljerad information",
  "Creating ticket...": "Skapar ärende...",
  "Status:": "Status:",
  "Created:": "Skapat:",
  "Last updated:": "Senast uppdaterat:",
  "Type your message here...": "Skriv ditt meddelande här...",
  "Sending reply...": "Skickar svar...",
  "Verify Email": "Verifiera e-post",
  "Verifying your email...": "Verifierar din e-post...",
  "Email verified successfully!": "E-posten har verifierats!",
  "Verification failed or token expired.":
    "Verifieringen misslyckades eller så har länken gått ut.",
  "Change Password": "Ändra lösenord",
  Active: "Aktiv",
  Resolved: "Löst",
  Pending: "Väntande",
  "General Support": "Allmän support",
  Billing: "Fakturering",
  Technical: "Tekniskt fel",
  "Order Issue": "Orderproblem",
  "Select a category": "Välj en kategori",
  "Enter subject": "Ange ämne",
  "Enter description": "Ange beskrivning",
  "Passwords do not match": "Lösenorden matchar inte",
  "Password must be at least 6 characters":
    "Lösenordet måste vara minst 6 tecken",
  "Updating password...": "Uppdaterar lösenord...",
  "Password updated successfully": "Lösenordet har uppdaterats",
  "Notifications saved": "Aviseringar sparade",
  "Order Updates": "Orderuppdateringar",
  "Get notified about your order status.": "Få aviseringar om din orderstatus.",
  Promotions: "Kampanjer",
  "Receive offers and deals.": "Få erbjudanden och rabatter.",
  Newsletters: "Nyhetsbrev",
  "Stay updated with company news.": "Håll dig uppdaterad med företagsnyheter.",
  "Save Preferences": "Spara inställningar",
  "Help Center": "Kundtjänst",
  "Frequently asked questions and guides.": "Vanliga frågor och guider.",
  "Billing & Payments": "Betalning & Fakturering",
  "Terms of Service": "Användarvillkor",
  "Privacy Policy": "Integritetspolicy",
  "Cookie Policy": "Cookiepolicy",
  "Shipping Policy": "Fraktpolicy",
  "Refund Policy": "Återbetalningspolicy",
  Item: "Produkt",
  Qty: "Antal",
  "Total Price": "Totalpris",
  "Delivery Method": "Leveranssätt",
  "Standard Shipping": "Standardfrakt",
  Free: "Gratis",
  "Payment Details": "Betalningsuppgifter",
  "Thank you for your order!": "Tack för din beställning!",
  "Your order number is": "Ditt ordernummer är",
  "We will send a confirmation email shortly.":
    "Vi skickar ett bekräftelsemejl inom kort.",
  "Continue Shopping": "Fortsätt handla",
  "Back to Orders": "Tillbaka till beställningar",
  "View Order": "Visa beställning",
  "Edit Profile": "Redigera profil",
  "No notifications": "Inga aviseringar",
  "Mark Read": "Markera som läst",
  "Cookie Consent": "Godkänn cookies",
  "We use cookies to improve your experience.":
    "Vi använder cookies för att förbättra din upplevelse.",
  "Accept All": "Godkänn alla",
  Reject: "Neka",
  "Manage Settings": "Hantera inställningar",
  "Product Details": "Produktdetaljer",
  "Customer Reviews": "Kundrecensioner",
  "Add Review": "Skriv recension",
  "Write your review here...": "Skriv din recension här...",
  "Submit Review": "Skicka recension",
  "Review submitted": "Recension skickad",
  "No reviews yet. Be the first!": "Inga recensioner än. Bli den första!",
  "Don't have an account?": "Har du inget konto?",
  "Create one": "Skapa ett",
  "Have questions or need assistance? Our team is here to help you with your tools and projects.":
    "Har du frågor eller behöver hjälp? Vårt team finns här för att hjälpa dig med dina verktyg och projekt.",
  "Email Us": "Mejla oss",
  "For general inquiries and support": "För allmänna frågor och support",
  "Business Hours": "Öppettider",
  "Monday – Friday": "Måndag – Fredag",
  "9:00 AM – 6:00 PM": "9:00 – 18:00",
  Saturday: "Lördag",
  "10:00 AM – 4:00 PM": "10:00 – 16:00",
  Sunday: "Söndag",
  Closed: "Stängt",
  "We typically respond within 24 hours": "Vi svarar vanligtvis inom 24 timmar",
  "Need specific help? Create a support ticket and our technical team will personally assist you with your issue.":
    "Behöver du specifik hjälp? Skapa ett supportärende så hjälper vårt tekniska team dig personligen.",
  "Create Support Ticket": "Skapa supportärende",
  "Tracking an existing ticket?": "Följer du ett befintligt ärende?",
  "Check Status": "Kontrollera status",
  "Before reaching out, you might find an instant answer in our FAQ section — available 24/7.":
    "Innan du kontaktar oss kan du kanske hitta ett svar direkt i vår FAQ – tillgänglig dygnet runt.",
  "Browse FAQs": "Bläddra bland vanliga frågor",
  User: "Användare",
  "Loading your settings...": "Laddar dina inställningar...",
  "Profile Settings": "Profilinställningar",
  "Update your personal information and billing address.":
    "Uppdatera din personliga information och faktureringsadress.",
  "Your full name": "Ditt fullständiga namn",
  "Email Address (cannot be changed)": "E-postadress (kan inte ändras)",
  "email@example.com": "email@example.com",
  "Email cannot be changed": "E-postadressen kan inte ändras",
  "Street name and number": "Gatunamn och nummer",
  "Zip Code": "Postnummer",
  "We only deliver to Sweden at this time":
    "Vi levererar endast till Sverige för närvarande",
  "Profile updated successfully!": "Profilen har uppdaterats!",
  "Failed to update profile": "Kunde inte uppdatera profilen",
  "Stay updated with your orders and account activity.":
    "Håll dig uppdaterad om dina beställningar och kontoaktivitet.",
  "Loading notifications...": "Laddar aviseringar...",
  "When you receive notifications, they will appear here.":
    "När du får aviseringar visas de här.",
  "Security Settings": "Säkerhetsinställningar",
  "Manage your account security and password.":
    "Hantera din kontosäkerhet och ditt lösenord.",
  "We recommend using a unique password that you don't use anywhere else.":
    "Vi rekommenderar ett unikt lösenord som du inte använder någon annanstans.",
  "Password changed successfully! Logging out...":
    "Lösenordet har ändrats! Loggar ut...",
  "Failed to change password": "Kunde inte ändra lösenordet",
  "Could not mark as read": "Kunde inte markera som läst",
  "Some notifications could not be marked as read.":
    "Vissa aviseringar kunde inte markeras som lästa.",
  "Coming Soon": "Kommer snart",
  "This setting module is currently under development.":
    "Denna inställningsmodul är under utveckling.",
  Profile: "Profil",
  Privacy: "Integritet",
  "Loading...": "Laddar...",
  "1 item saved": "1 produkt sparad",
  "{count} items saved": "{count} produkter sparade",
  "Save items you like to find them easily later.":
    "Spara produkter du gillar för att enkelt hitta dem senare.",
  "Close cart": "Stäng varukorg",
  Sale: "Rea",
  "Clear Cart": "Rensa varukorg",
  "Discount code": "Rabattkod",
  Shipping: "Frakt",
  Discount: "Rabatt",
  Apply: "Använd",
  "Remove discount": "Ta bort rabatt",
  "Sale items cannot use discount codes":
    "Reavaror kan inte använda rabattkoder",
  "Decrease quantity": "Minska antal",
  "Increase quantity": "Öka antal",
  "Remove item": "Ta bort produkt",
  "Total Orders": "Totalt antal beställningar",
  Processed: "Behandlade",
  Cancelled: "Avbruten",
  Paid: "Betald",
  Processing: "Behandlas",
  Shipped: "Skickad",
  "Validating...": "Validerar...",
  Delivered: "Levererad",
  "Payment required to start processing this order":
    "Betalning krävs för att behandla denna beställning",
  "Payment received and your order has been confirmed":
    "Betalning mottagen och din beställning har bekräftats",
  "Your order is being prepared for shipment":
    "Din beställning förbereds för leverans",
  "Your order is on the way": "Din beställning är på väg",
  "Your order has been delivered successfully":
    "Din beställning har levererats",
  "This order has been cancelled": "Denna beställning har avbrutits",
  "View your order details and status updates":
    "Visa dina beställningsdetaljer och statusuppdateringar",
  "Track and manage your recent purchases":
    "Spåra och hantera dina senaste köp",
  "Search by order number or status": "Sök efter ordernummer eller status",
  Clear: "Rensa",
  "Try Again": "Försök igen",
  "No orders yet": "Inga beställningar än",
  "You haven't placed any orders yet. Start shopping to see your orders here.":
    "Du har inte lagt några beställningar än. Börja handla för att se dina beställningar här.",
  "No matching orders": "Inga matchande beställningar",
  'We couldn\'t find any orders matching "{query}".':
    'Vi kunde inte hitta några beställningar som matchar "{query}".',
  "Clear Search": "Rensa sökning",
  Placed: "Placerad",
  "Payment required to process this order":
    "Betalning krävs för att behandla denna beställning",
  "View Details": "Visa detaljer",
  "Failed to load orders": "Kunde inte ladda beställningar",
  "Remove from wishlist": "Ta bort från önskelistan",
  "Add to wishlist": "Lägg till i önskelistan",
  Ticket: "Ärende",
  "Back to Tickets": "Tillbaka till ärenden",
  You: "Du",
  "Support Team": "Supportteam",
  Send: "Skicka",
  "Type your reply...": "Skriv ditt svar...",
  "Close Ticket": "Stäng ärende",
  "Closing...": "Stänger...",
  "This ticket is closed. Create a new ticket if you need further assistance.":
    "Detta ärende är stängt. Skapa ett nytt ärende om du behöver ytterligare hjälp.",
  Priority: "Prioritet",
  "Related Order": "Relaterad beställning",
  "Loading ticket...": "Laddar ärende...",
  "Failed to load ticket": "Kunde inte ladda ärende",
  "File must be under 5MB": "Filen måste vara under 5MB",
  "File uploaded": "Fil uppladdad",
  "Failed to upload file": "Kunde inte ladda upp fil",
  "Are you sure you want to close this ticket?":
    "Är du säker på att du vill stänga detta ärende?",
  "Ticket closed": "Ärende stängt",
  "Failed to close ticket": "Kunde inte stänga ärende",
  "Remove attachment": "Ta bort bifogad fil",
  "Attach file": "Bifoga fil",
  Open: "Öppen",
  Low: "Låg",
  Medium: "Medel",
  High: "Hög",
  Urgent: "Brådskande",
  Payment: "Betalning",
  Returns: "Returer",
  Other: "Annat",
  "Manage your support requests and track responses from our team.":
    "Hantera dina supportförfrågningar och följ svar från vårt team.",
  "New Ticket": "Nytt ärende",
  "No tickets found": "Inga ärenden hittades",
  "You haven't created any support tickets yet.":
    "Du har inte skapat några supportärenden än.",
  "No {filter} tickets at the moment.": "Inga {filter} ärenden för tillfället.",
  "Create Your First Ticket": "Skapa ditt första ärende",
  "Tell us what's going on and we'll get back to you shortly.":
    "Berätta vad som händer så återkommer vi till dig inom kort.",
  "Brief summary of your issue": "Kort sammanfattning av ditt problem",
  "Provide as much detail as possible...":
    "Ge så mycket detaljer som möjligt...",
  Cancel: "Avbryt",
  "Creating...": "Skapar...",
  "Subject and description are required": "Ämne och beskrivning krävs",
  "Ticket created successfully": "Ärende skapat",
  "Failed to create ticket": "Kunde inte skapa ärende",
  "Failed to load tickets": "Kunde inte ladda ärenden",
  "— No specific order —": "— Ingen specifik beställning —",
  "You don't have any orders yet.": "Du har inga beställningar än.",
  Updated: "Uppdaterad",
  Opened: "Öppnad",
  "Order Placed": "Beställning lagd",
  "Payment Confirmed": "Betalning bekräftad",
  "Failed to load order details": "Kunde inte ladda orderdetaljer",
  "Order Not Found": "Beställning hittades inte",
  "We couldn't find the order you're looking for.":
    "Vi kunde inte hitta beställningen du letar efter.",
  "Back to My Orders": "Tillbaka till mina beställningar",
  "Copy order number": "Kopiera ordernummer",
  "Payment Required": "Betalning krävs",
  "This order is pending payment. Click below to securely pay via Stripe.":
    "Denna beställning väntar på betalning. Klicka nedan för att betala säkert via Stripe.",
  "Pay Now": "Betala nu",
  "Not Enough Stock": "Otillräckligt lager",
  "One or more items in your order are not in stock. Payment cannot be processed at this time.":
    "En eller flera produkter i din beställning finns inte i lager. Betalning kan inte behandlas just nu.",
  "Order Items": "Beställningsprodukter",
  item: "produkt",
  items: "produkter",
  "No address information available.": "Ingen adressinformation tillgänglig.",
  "Delivery Info": "Leveransinformation",
  "Updates will be sent to your registered email address.":
    "Uppdateringar skickas till din registrerade e-postadress.",
  "Cancel Order": "Avbryt beställning",
  "You can cancel this order before it ships. If payment was already processed, it will be refunded.":
    "Du kan avbryta denna beställning innan den skickas. Om betalning redan har behandlats kommer den att återbetalas.",
  "Request Refund": "Begär återbetalning",
  "This order is eligible for a refund. You'll be redirected to create a support ticket.":
    "Denna beställning är berättigad till återbetalning. Du omdirigeras för att skapa ett supportärende.",
  "Are you sure you want to cancel this order? This action cannot be undone.":
    "Är du säker på att du vill avbryta denna beställning? Denna åtgärd kan inte ångras.",
  "Yes, Cancel Order": "Ja, avbryt beställning",
  "No, Keep Order": "Nej, behåll beställning",
  "Are you sure you want to request a refund? You will be redirected to create a support ticket.":
    "Är du säker på att du vill begära återbetalning? Du kommer att omdirigeras för att skapa ett supportärende.",
  "Yes, Request Refund": "Ja, begär återbetalning",
  "Order cancelled successfully. If payment was processed, it will be refunded shortly.":
    "Beställningen avbröts. Om betalning har gjorts återbetalas den inom kort.",
  "Failed to cancel order. Please try again later.":
    "Kunde inte avbryta beställningen. Försök igen senare.",
  "Refund Request for Order": "Återbetalningsbegäran för beställning",
  "I would like to request a refund for order #{orderNum}.":
    "Jag vill begära återbetalning för beställning #{orderNum}.",
  "Processing Payment...": "Behandlar betalning...",
  "Please complete the payment in the new tab.":
    "Slutför betalningen i den nya fliken.",
  "This page will update automatically once confirmed.":
    "Denna sida uppdateras automatiskt när betalningen är bekräftad.",
  "Close Loader": "Stäng laddare",
  "Order Cancelled": "Beställning avbruten",
  "This order has been cancelled. If a payment was made, a refund will be processed shortly.":
    "Denna beställning har avbrutits. Om betalning har gjorts återbetalas den inom kort.",
  "We value your privacy": "Vi värdesätter din integritet",
  'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of all cookies. You can manage your preferences or learn more by clicking "Cookie Settings".':
    'Vi använder cookies för att förbättra din surfupplevelse, analysera webbplatstrafik och anpassa innehåll. Genom att klicka på "Acceptera alla" godkänner du vår användning av alla cookies. Du kan hantera dina inställningar eller läsa mer genom att klicka på "Cookie-inställningar".',
  "Cookie Settings": "Cookie‑inställningar",
  "Reject All": "Avvisa alla",
  "Strictly Necessary": "Strikt nödvändiga",
  "Essential cookies required for the Site to function — authentication, cart, security. Cannot be disabled.":
    "Nödvändiga cookies som krävs för att webbplatsen ska fungera – inloggning, varukorg, säkerhet. Kan inte inaktiveras.",
  Functional: "Funktionella",
  "Remember your preferences (language, region) for a personalized experience.":
    "Kom ihåg dina inställningar (språk, region) för en personlig upplevelse.",
  Analytical: "Analytiska",
  "Help us understand how visitors use the Site so we can improve it. All data is anonymized.":
    "Hjälp oss att förstå hur besökare använder webbplatsen så att vi kan förbättra den. All data är anonymiserad.",
  Marketing: "Marknadsföring",
  "Used to deliver relevant advertisements and measure campaign effectiveness.":
    "Används för att visa relevanta annonser och mäta kampanjeffektivitet.",
  "Cookie Preferences": "Cookie‑inställningar",
  Close: "Stäng",
  "We use cookies and similar technologies to ensure the Site functions correctly, enhance your experience, analyze usage, and deliver relevant content. You can choose which categories to accept below.":
    "Vi använder cookies och liknande tekniker för att se till att webbplatsen fungerar korrekt, förbättra din upplevelse, analysera användning och leverera relevant innehåll. Du kan välja vilka kategorier du accepterar nedan.",
  "Always required": "Alltid nödvändig",
  "Toggle {category} cookies": "Växla {category} cookies",
  "Accept Only Necessary": "Acceptera endast nödvändiga",
  "Search for questions...": "Sök efter frågor...",
  "Found {totalResults} {results}": "Hittade {totalResults} {results}",
  result: "resultat",
  results: "resultat",
  "No questions match your search. Please try different keywords.":
    "Inga frågor matchar din sökning. Försök med andra sökord.",
  "Contact Support": "Kontakta kundtjänst",
  "Still have questions?": "Har du fortfarande frågor?",
  "Our support team is ready to help you.":
    "Vårt supportteam är redo att hjälpa dig.",
  "Find quick answers to common questions about orders, payments, shipping, and more.":
    "Hitta snabba svar på vanliga frågor om beställningar, betalningar, frakt och mer.",
  "Find answers to common questions about orders, payments, shipping, and more.":
    "Hitta svar på vanliga frågor om beställningar, betalningar, frakt och mer.",
  "On this page": "På denna sida",
  "Standard Withdrawal Form": "Standardformulär för ångerrätt",
  "Complete and email this form to": "Fyll i och skicka detta formulär till",
  "or mail it to our return address.": "eller posta det till vår returadress.",
  Name: "Namn",
  Provider: "Leverantör",
  Purpose: "Syfte",
  Duration: "Varaktighet",
  "Email Verification": "E-postverifiering",
  "Please wait a moment.": "Vänligen vänta ett ögonblick.",
  "Email Verified!": "E-posten har verifierats!",
  "Continue to Login": "Fortsätt till inloggning",
  "Verification Failed": "Verifiering misslyckades",
  "Didn't receive the email or link expired?":
    "Har du inte fått e-posten eller har länken gått ut?",
  "Resend Verification": "Skicka igen",
  "Check Your Inbox": "Kontrollera din inkorg",
  "Please check your email for the verification link.":
    "Kontrollera din e-post för verifieringslänken.",
  "Verification failed. The link may be invalid or expired.":
    "Verifieringen misslyckades. Länken kan vara ogiltig eller ha gått ut.",
  "Please enter your email address.": "Ange din e-postadress.",
  "Failed to resend verification email.":
    "Kunde inte skicka om verifieringsmeddelandet.",
  "Back to Shop": "Tillbaka till butiken",
  "Pop-up Blocked": "Popup-fönster blockerat",
  "Your browser blocked the payment window. Your order has been created — please click the button below to open the payment page manually.":
    "Din webbläsare blockerade betalningsfönstret. Din beställning har skapats — klicka på knappen nedan för att öppna betalningssidan manuellt.",
  "Open Payment Page": "Öppna betalningssidan",
  each: "styck",
  "This address is pulled from your account. To deliver to a different address, please update it in your":
    "Denna adress hämtas från ditt konto. För leverans till en annan adress, vänligen uppdatera den i dina",
  "Proceed to Payment": "Fortsätt till betalning",
  "Secure payment via Stripe. You'll be redirected to complete your purchase.":
    "Säker betalning via Stripe. Du omdirigeras för att slutföra ditt köp.",
  "Failed to create checkout session": "Kunde inte skapa kassasession",
  "An error occurred during checkout": "Ett fel uppstod vid kassan",
  From: "Från",
  Select: "Välj",
  "Select Options": "Välj alternativ",
  "Please select all options before adding to cart.":
    "Vänligen välj alla alternativ innan du lägger i varukorgen.",
  "Free Shipping": "Fri frakt",
  "Account Details": "Kontouppgifter",
  "Billing Address": "Faktureringsadress",
  Continue: "Fortsätt",
  Back: "Tillbaka",
  "Address not found. Please select a valid address from the suggestions.":
    "Adressen hittades inte. Välj en giltig adress från förslagen.",
  "Validating Address...": "Validerar adress...",
  "Shipping Addresses": "Leveransadresser",
  "Add Address": "Lägg till adress",
  "Add Shipping Address": "Lägg till leveransadress",
  "Edit Shipping Address": "Redigera leveransadress",
  "Label (optional)": "Etikett (valfritt)",
  "e.g. Home, Work": "t.ex. Hem, Arbete",
  "Use billing address": "Använd faktureringsadress",
  "Save Address": "Spara adress",
  "Delete this shipping address?": "Ta bort denna leveransadress?",
  "Shipping address saved.": "Leveransadress sparad.",
  "Shipping address removed.": "Leveransadress borttagen.",
  "Default shipping address updated.": "Standardleveransadress uppdaterad.",
  Default: "Standard",
  "Set as default": "Sätt som standard",
  Delete: "Ta bort",
  Edit: "Redigera",
  "Manage up to 3 shipping addresses for faster checkout.":
    "Hantera upp till 3 leveransadresser för snabbare kassa.",
  "No shipping addresses yet": "Inga leveransadresser ännu",
  "Add a shipping address to speed up checkout.":
    "Lägg till en leveransadress för snabbare kassa.",
  "Loading shipping addresses...": "Läser in leveransadresser...",
  "Failed to load shipping addresses": "Kunde inte läsa in leveransadresser",
  "Failed to save shipping address": "Kunde inte spara leveransadress",
  "Failed to delete shipping address": "Kunde inte ta bort leveransadress",
  "Failed to set default shipping address":
    "Kunde inte sätta standardleveransadress",
  "Choose where to ship your order": "Välj vart din beställning ska skickas",
  "Manage shipping addresses": "Hantera leveransadresser",
  "The address shown is the one you selected above.":
    "Adressen som visas är den du valde ovan.",
  "You can have up to 3 shipping addresses.":
    "Du kan ha upp till 3 leveransadresser.",
  "This address is used for your invoices and can be copied to shipping.":
    "Denna adress används för dina fakturor och kan kopieras till leverans.",
  "Please fill in your billing address.":
    "Vänligen fyll i din faktureringsadress.",
  "Remember me": "kom ihåg mig",
  "Choose Options": "Välj alternativ",
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("store_lang");
    return saved || "sv";
  });

  useEffect(() => {
    localStorage.setItem("store_lang", language);
    document.documentElement.lang = language === "sv" ? "sv-SE" : "en";
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const t = (key) => {
    if (language === "en") {
      return key;
    }
    return translations[key] || key;
  };

  const translateNotification = (text) => {
    if (language === "en") return text;
    if (translations[text]) return translations[text];
    let result = text;
    for (const [en, sv] of Object.entries(translations)) {
      const escapedEn = en.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      result = result.replace(new RegExp(escapedEn, "g"), sv);
    }
    return result;
  };

  return (
    <LanguageContext.Provider
      value={{ language, changeLanguage, t, translateNotification }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
